const LEGACY_KEY = 'learnerSupportGuestThreads'

export function clearLegacySupportGuestLocalStorage(): void {
  if (typeof window === 'undefined') return
  try {
    localStorage.removeItem(LEGACY_KEY)
  } catch {
    // ignore
  }
}
